import React from "react";

function Loading(){
  return <div style={{width: "100%", textAlign: "center"}}><img src="infinity.gif" alt="Loading..."/></div>
}

export default Loading
